<template>
  <div>
    <!--排行榜列表-->
    <v-dialog
        v-model="dialog"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ ranking.label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>clear_all</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="mt-5" v-if="dialog">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                </th>
                <th class="text-left">
                </th>
                <th class="text-left">
                  英雄
                </th>
                <th class="text-left">
                  位置
                </th>
                <th class="text-left">
                  出场率
                </th>
                <th class="text-left">
                  胜率
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in ranking.statisticsList"
                  :key="index">
                <td>
                  <div class="text-h6"
                       :class="item.ranking == 1 ? 'red--text' : item.ranking == 2 ? 'indigo--text' : item.ranking == 3 ? 'orange--text' : ''">
                    <v-icon
                        :color="item.ranking == 1 ? 'red' : item.ranking == 2 ? 'indigo' : item.ranking == 3 ? 'orange' : ''">
                      military_tech
                    </v-icon>
                    {{ `${item.ranking}` }}
                  </div>
                </td>
                <td>
                  <v-img :src="item.img" height="50" width="50" class="rounded-circle"/>
                </td>
                <td>
                  <div class="my-5">
                    {{ item.name }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ item.position }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ (item.pickRate * 1).toFixed(2) }}%
                  </div>
                </td>
                <td>
                  <div>
                    {{ (item.winRate * 1).toFixed(2) }}%
                  </div>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card>
    </v-dialog>


    <div>
      <v-speed-dial
          :value="!dialog"
          bottom
          right
          fixed
          direction="top"
          transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn
              :value="!dialog"
              class="pa-1"
              fab
              @click="showDialog"
          >
            <v-icon>format_list_numbered</v-icon>
          </v-btn>
        </template>

      </v-speed-dial>
    </div>

  </div>
</template>

<script>
export default {
  name: "Rank",
  props: {
    tab: undefined,
    positionList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    dialog: false,
    ranking: {}
  }),
  methods: {
    showDialog() {
      let {statisticsList, label} = this.positionList[this.tab]
      this.ranking = {
        statisticsList,
        label
      }
      this.dialog = true
    },
  }
}
</script>

<style scoped>

</style>
